import React from "react";
import { observer } from "mobx-react";
import { Typography, Box, Alert, Button } from "@mui/material";
import { Spinner } from "/@/app/components/Spinner";
import { freeMeasurementsViewState } from "/@/app/views/FreeMeasurementsView/FreeMeasurementsViewState";


export const DeleteParameter = observer(({ state, onDone }) => {

    const isSaving = state.saveStatus === "saving";

    const doDelete = () => {
        if (isSaving) {
            return;
        }

        state.delete().then(() => {
            onDone();
        });
    }

    return (
        <>
            <Typography variant="h6" component="h2">
                Удалить параметр "{state.name}"
            </Typography>

            <Alert severity="error">
                Все измерения этого параметра будут удалены!
            </Alert>

            <Box sx={{ textAlign: "center" }}>
                <Button
                    variant="contained"
                    color="error"
                    onClick={doDelete}
                    disabled={isSaving}
                    sx={{ mt: 2 }}
                >
                    {isSaving
                        ? <Spinner size={30} sx={{ color: "white" }}/>
                        : "Удалить навсегда"
                    }
                </Button>
            </Box>
        </>
    );
});
